// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"f70c3ba1","239":"7d3649d5","349":"7aff3739","354":"fc3af50f","521":"22cf93a5","538":"38660765","555":"4e3621db","610":"ef55f40f","806":"0facb14d","813":"d0adae61","963":"405e65c1","988":"de65c20f"}[chunkId] + ".chunk.js";
};